import { Card, Row, Col } from 'antd';
import React from 'react';
import Auxiliary from '../../../util/Auxiliary';
import Item from './Item';
import { useViolation } from './data';
import Chart from './Charts/Violation';

const ViolationStatistic = () => {
  const { loading, violation } = useViolation();
  return (
    <Auxiliary>
      <Card className="gx-card gx-p-15 gx-text-center" title="Pelanggaran">
        {loading ? "Sedang memuat..." : (
          <Row>
            {violation.map((item, key) => {
              return (
                <Col span={8} key={key}>
                  <Item label={item.name} value={item.value} loading={loading} />
                </Col>
              );
            })}
          </Row>
        )}
        <hr />
        <Chart loading={loading} violation={violation} />
      </Card>
    </Auxiliary>
  );
}

export default ViolationStatistic;